import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';

/** Each core volume in detail — text cards, no cover images. */
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-205" data-mp="3zv20e1x1hc7">
      <div className="mx-auto max-w-6xl" data-id="element-206" data-mp="816t6o0fuami">
        <SectionHeading id="volumes-heading" title={<>
              6 Volumes. <Accent data-id="element-208" data-mp="10oatwgsi02sh">One Complete Teaching System.</Accent>
            </>} data-id="element-207" data-mp="vooeq1t40ch1" />

        <ol className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-209" data-mp="mxfojeh7k3tn">
          {volumes.map(volume => <li key={volume.number} data-id="element-210" data-mp="qxg3d087yh18">
              <article className="flex h-full flex-col rounded-[24px] border border-brand-charcoal/8 bg-white p-6 shadow-[0_30px_60px_-44px_rgba(59,27,87,0.5)] sm:p-8" data-id="element-211" data-mp="qwofkbkv5nli">
                <div className="flex items-center justify-between gap-4" data-id="element-212" data-mp="1jfkd5hs2m5x9">
                  <span className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/50" data-id="element-213" data-mp="ckzvmimnm9ag">
                    Volume {volume.number}
                  </span>
                  <span className="rounded-full bg-brand-lavender px-3 py-1 font-body text-[11px] font-bold uppercase tracking-[0.16em] text-brand-plum" data-id="element-214" data-mp="mb2rcql5u1ch">
                    {volume.stage}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-[1.7rem] font-bold leading-[1.1] text-brand-charcoal sm:text-[1.9rem]" data-id="element-215" data-mp="vapsrcdw375j">
                  {volume.title}
                </h3>
                <p className="mt-2 text-[15px] font-medium leading-relaxed text-brand-charcoal/75" data-id="element-216" data-mp="15agkx7ez9a2g">{volume.benefit}</p>

                <ul className="mt-5 grid grid-cols-2 gap-x-5 gap-y-2 border-t border-brand-charcoal/10 pt-5" role="list" data-id="element-217" data-mp="10bvm9cfdiyg4">
                  {volume.includes.map(item => <li key={item} className="flex items-start gap-2 text-[14px] leading-snug text-brand-charcoal/80" data-id="element-218" data-mp="322qk09t557ph">
                      <span aria-hidden="true" className="mt-[7px] h-1 w-1 flex-none rounded-full bg-brand-gold" data-id="element-219" data-mp="1603zckqbko1m" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-auto pt-6" data-id="element-220" data-mp="1eyz5jwtd5y4x">
                  <div className="rounded-[14px] bg-brand-lavender px-5 py-4" data-id="element-221" data-mp="1jytv9x1ekhoe">
                    <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-plum" data-id="element-222" data-mp="1jwquqj2mj65f">
                      Use it when…
                    </p>
                    <p className="mt-1.5 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-223" data-mp="1tvq3s2rax3sy">{volume.useWhen}</p>
                  </div>
                </div>
              </article>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-224" data-mp="22rfkvzlpvc0j">
          Stop preparing everything <Accent data-id="element-225" data-mp="2cokcieybzzoq">from scratch.</Accent>
        </p>
        <CtaBlock label="Yes! I Want My Classes Ready" className="mt-6" data-id="element-226" data-mp="2cl67eyya9cdl" />
      </div>
    </section>;
}